import * as React from "react";
import { IForm } from '../IForm';

export interface SearchPanelProps<T>
{
    onSearch?: (sender: IForm) => void;
    onChange?: (sender: IForm) => void;

    searchInProgress?: boolean;
    errorMessage?: string;

    searchParams?: T;
}

export abstract class SearchForm<P extends SearchPanelProps<any>, S> extends React.Component<P, S> implements IForm
{
    abstract getValue(): any;

    protected onSubmit(e: React.FormEvent<HTMLFormElement>)
    {
        e.preventDefault();
        const { onSearch } = this.props;
        if(onSearch) {
            onSearch(this);
        }
    }

    protected onChange()
    {
        const { onChange } = this.props;
        if(onChange) {
            onChange(this);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Search/Search.ts